import React from 'react';

import styles from '../config/styles';
import Subscribe from './subscribe';
import { withStyles, Modal } from '../../node_modules/@material-ui/core';

class Popup extends React.Component {
    render(){
        const {classes} = this.props;
        return(
            <section className={classes.popup}>
                <Modal
                    aria-labelledby="subscribe"
                    aria-describedby="Be updated on our projects"
                    open={this.props.popupOpen}
                    onClose={this.props.handlePopupClose}
                    >
                    <Subscribe />                    
                    </Modal>
            </section>
        )
    }
};

export default withStyles(styles)(Popup);